import HomePage from "./pages/HomePage";
import Header from "./components/Header";
import Footer from "./components/Footer";
import { Box } from "@chakra-ui/react";
import { Routes, Route } from "react-router-dom";
import React from "react";
import HealthPage from "./pages/HealthPage";
import LawsPage from "./pages/LawsPage";
import EducationPage from "./pages/EducationPage";
import EconomyPage from "./pages/EconomyPage";
import EmploymentPage from "./pages/EmploymentPage";
import EnvironmentPage from "./pages/EnvironmentPage";
import ParticipationPage from "./pages/ParticipationPage";
import BasicDigitalSkillsPage from "./pages/BasicDigitalSkillsPage";
import AboutPage from "./pages/AboutPage";


// import MapPage from "./pages/MapPage";

function App() {
  return (
    <>
      <Header />
      <Box as="main" pb={{ base: "160px", md: "140px", lg: "120px" }}>
        <Routes>
          <Route index element={<HomePage />} />
          <Route path="/health" element={<HealthPage />} />
          <Route path="/laws" element={<LawsPage />} />
          <Route path="/education" element={<EducationPage />} />
          <Route path="/economy" element={<EconomyPage />} />
          <Route path="/employment" element={<EmploymentPage />} />
          <Route path="/environment" element={<EnvironmentPage />} />
          <Route path="/participation" element={<ParticipationPage />} />
          <Route path="/skills" element={<BasicDigitalSkillsPage />} />
          <Route path="/about" element={<AboutPage />} />
        </Routes>
      </Box>
      <Footer />
    </>
  );
}

export default App;